/** True when the app is serving the participant portal (subdomain, partner host, or hash study link). */
export function isParticipantDomain() {
  const domain = window.location.hostname;
  if (domain === 'participant.flexcoa.com' || domain === 'fresenius.flexcoa.com') {
    return true;
  }
  return document.location.href.indexOf('#') !== -1;
}
